export const getTimezone = () => {
  const currentLocation = Intl.DateTimeFormat().resolvedOptions();
  const browserTimeZone = currentLocation.timeZone;
  return {
    timezoneId: browserTimeZone || 'America/Los_Angeles',
    timezoneMethod: browserTimeZone ? 'browser' : 'default'
  };
};
